module.exports = __webpack_public_path__ + "img/1761987618431-vB34Duyh.12282eba.png";